<template>
  <div>
    <div class="p-grid">
      <div ref="view1" class="bullauge p-col-12 p-lg-6">
        <button
          type="button"
          @click="toggle('view1')"
          class="p-button p-component p-button-text-icon-right"
        >
          <span class="pi pi-external-link p-button-icon-right"></span
          ><span class="p-button-text p-c">Zeigr nur Darmstadt</span>
        </button>
        <Belegungsplan studioname="Darmstadt" />
      </div>
      <div class="bullauge p-col-12 p-lg-6">
        <Belegungsplan studioname="Ginsheim-Gustavsburg" />
      </div>
      <div class="bullauge p-col-12 p-lg-6">
        <Belegungsplan studioname="Groß-Gerau" />
      </div>
      <div class="bullauge p-col-12 p-lg-6">
        <Belegungsplan studioname="Wiesbaden" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bullauge {
  max-height: 25%;
  transition: width 1s, height 1s;
}
.maximized {
  height: 100%;
  width: 100%;
}
.hidden {
  display: none;
}
</style>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "StudiosUebersicht",
  methods: {
    toggle(viewName) {
      const view = this.$refs[viewName];
      console.log(viewName);
      console.log(event);
      console.log(view);
      const classes = this.$refs[viewName].classList;
      if (classes.contains("maximized")) {
        classes.remove("maximized");
      } else {
        classes.add("maximized");
      }
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
  },
  data() {
    return {
      fullscreen: false,
    };
  },
});
</script>
